export enum CastingTypes {
  Online = "1",
  SelfTape = "2",
  InPerson = "3",
  Other = "4",
}
